// extracted by mini-css-extract-plugin
export default {"wrapper":"Nav_wrapper__IRRfw","menuItem":"Nav_menuItem__1ZkW7","active":"Nav_active__3h2eF"};